import { Checkbox as MuiCheckbox, Link, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const IconButton = styled(Link)`
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  background: ${variables.color.background};
  border-radius: 50%;
  cursor: pointer;
  svg {
    color: ${variables.color.secondary};
  }

  &:hover {
    background: #ddebfa;
    svg {
      color: ${variables.color['secondary-hover']};
    }
  }
`;

export const Checkbox = styled(MuiCheckbox)`
  .MuiCheckbox-root {
    pointer-events: visible !important;
  }
`;
